export default {
  namespaced: true,

  state: {
    show: false,
    type: null,
    metaData: null,
  },

  mutations: {
    openPopup(state, { type, metaData }) {
      state.show = true;
      state.type = type;
      state.metaData = metaData;
    },

    closePopup(state) {
      state.show = false;
      state.type = null;
      state.metaData = null;
    },
  },
};
